import { render, staticRenderFns } from "./scoreCollect.vue?vue&type=template&id=2cd6a7ea&scoped=true"
import script from "./scoreCollect.vue?vue&type=script&lang=js"
export * from "./scoreCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6a7ea",
  null
  
)

export default component.exports